module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [(_vm.showLoading) ? _c('md-progress', {
    staticClass: "progress md-accent",
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('md-whiteframe', {
    staticClass: "content row center-xs middle-xs"
  }, [_c('section', {
    staticClass: "lang col-md-4"
  }, [_c('md-menu', [_c('md-button', {
    attrs: {
      "md-menu-trigger": ""
    }
  }, [(_vm.currentLang == 'hu') ? _c('span', [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": require("../assets/flag_hu.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("HUN")])]) : _c('span', [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": require("../assets/flag_gb.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("ENG")])])]), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.changeLang('en')
      }
    }
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": require("../assets/flag_gb.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("ENG")])]), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.changeLang('hu')
      }
    }
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": require("../assets/flag_hu.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("HUN")])])], 1)], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "logo col-md-4",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/pulmoment_wide.png")
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "menu col-md-4"
  })], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right",
    on: {
      "open": function($event) {
        _vm.open('Right')
      },
      "close": function($event) {
        _vm.close('Right')
      }
    }
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("sign_in")))])])]), _vm._v(" "), _c('div', {
    staticClass: "auth"
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("email")))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("password")))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('md-checkbox', {
    model: {
      value: (_vm.rememberMail),
      callback: function($$v) {
        _vm.rememberMail = $$v
      },
      expression: "rememberMail"
    }
  }, [_vm._v("E-mail cím megjegyzése")]), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t("sign_in")))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-warn",
    on: {
      "click": _vm.closeRightSidenav
    }
  }, [_vm._v(_vm._s(_vm.$t("cancel")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("signin_note")))]), _vm._v(" "), _c('router-link', {
    staticClass: "md-primary",
    attrs: {
      "tag": "md-button",
      "to": "/registration"
    }
  }, [_vm._v(_vm._s(_vm.$t("registration")))]), _vm._v(" "), _c('p', [_vm._v("Elfelejtett jelszó esetén adja meg a fenti mezőben az e-mail címét és kattintson az alábbi gombra:")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.passwordReset
    }
  }, [_vm._v("Jelszó visszaállítás")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05ec0a75!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 407
// module chunks = 2